module.exports = __webpack_public_path__ + "static/media/about5__.7bff8d21.jpg";